export const truncateString = (s: string, limit: number) => {
    if (s.length >= limit) {
        return `${s.substring(0, limit)}...`
    }
    return s
}

/**
 * Abrevia um nome completo, ex: 'Julio Augusto Cezar' para 'Julio Cezar'
 * @param fullName Nome completo como string com nomes separados por ' '
 * @returns string contendo apenas o primeiro e último nome. Se só tiver 1 nome, não altera o valor
 */
export const abreviateFullName = (fullName: string) => {
    const names = fullName.split(' ');
    if (names.length == 1) {
        return names[0]
    } 
    const firstName = names[0]
    const lastName =  names[ names.length - 1 ]
    return `${firstName} ${lastName}`
}